import React from 'react';
import { DateTimePicker } from '@components/date-picker';
import { Button } from '@components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle
} from '@components/ui/dialog';
import { ChallengeLeaderboardEntry } from './types';

interface EditJoinDateDialogProps {
    entry: ChallengeLeaderboardEntry | null;
    loading?: boolean;
    onClose(): void;
    onSubmit(subscriptionId: number, createdDate: string): Promise<void>;
}

export function EditJoinDateDialog({
    entry,
    loading,
    onClose,
    onSubmit
}: EditJoinDateDialogProps) {
    const [value, setValue] = React.useState<Date | null>(null);

    React.useEffect(() => {
        setValue(entry ? new Date(entry.joinTimestamp) : null);
    }, [entry]);

    const invalid = !value || value.getTime() > Date.now();

    return (
        <Dialog
            open={Boolean(entry)}
            onOpenChange={(next) => !next && onClose()}
        >
            <DialogContent className="sm:max-w-xs">
                <DialogHeader>
                    <DialogTitle>Edit Join Timestamp</DialogTitle>
                </DialogHeader>
                <DateTimePicker
                    label="Join timestamp"
                    value={value}
                    onChange={setValue}
                />
                <DialogFooter>
                    <Button
                        variant="ghost"
                        onClick={onClose}
                        disabled={loading}
                    >
                        Cancel
                    </Button>
                    <Button
                        disabled={!entry || invalid}
                        loading={loading}
                        onClick={() => {
                            if (!entry || !value) {
                                return;
                            }
                            void onSubmit(
                                entry.subscriptionId,
                                value.toISOString()
                            );
                        }}
                    >
                        Save
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
